<template>
  <div class="containerCenter">
    <div class="top">
      <a-radio-group v-model="check" @change="handleChange" size="large">
        <a-radio-button v-for="(item, index) in mineList" :value="item.id" :key="index">
          {{ item.title }}1222
        </a-radio-button>
      </a-radio-group>
    </div>
    <div class="bottom">
      <div v-if="check == 1">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane key="1" tab="全部">
            <Tasking></Tasking>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div v-if="check == 2">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane :key="item.id" :tab="item.title" v-for="item in taskList" :value="item.id">
            <BusinessList></BusinessList>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div v-if="check == 3">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane :key="item.id" :tab="item.title" v-for="item in taskList" :value="item.id">
            Content of Tab Pane 3
          </a-tab-pane>
        </a-tabs>
      </div>
      <div v-if="check == 4">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane :key="item.id" :tab="item.title" v-for="item in taskList" :value="item.id">
            Content of Tab Pane 4
          </a-tab-pane>
        </a-tabs>
      </div>
      <div v-if="check == 5">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane :key="item.id" :tab="item.title" v-for="item in taskList" :value="item.id">
            Content of Tab Pane 5
          </a-tab-pane>
        </a-tabs>
      </div>
      <div v-if="check == 6">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane :key="item.id" :tab="item.title" v-for="item in taskList" :value="item.id">
            Content of Tab Pane 6
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Tasking from './Tasking.vue'
import BusinessList from './BusinessList.vue'
export default {
   components: {
     Tasking,
     BusinessList

    },
  data() {
    return {
      check: 1,
      mineList: [
        {
          id: 1,
          title: '我的待办2',
        },
        {
          id: 2,
          title: '我的申请',
        },
        {
          id: 3,
          title: '我的已办',
        },
        {
          id: 4,
          title: '抄送我的',
        },
        {
          id: 5,
          title: '我的或签',
        },
        {
          id: 6,
          title: '我的转交',
        },
      ],
      taskList: [
        {
          id: 1,
          title: '全部',
        },
        {
          id: 2,
          title: '审批中',
        },
        {
          id: 3,
          title: '已通过',
        },
        {
          id: 4,
          title: '已驳回',
        },
        {
          id: 5,
          title: '已撤销',
        },
        {
          id: 6,
          title: '已终止',
        },
      ],
    }
  },
  methods: {
    handleChange(e) {
      console.log(e, this.check, 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
    },
  },
}
</script>

<style scoped lang="less">
.containerCenter{
  width: 100%;
  height: 100%;
  float: left;
 
}
</style>